import project from './projectManage';
import base from './base';
import achievement from './achievement';

export default {
    project,
    base,
    achievement
}